import { Unit } from './../../models/unit';
import { NestedTreeControl } from '@angular/cdk/tree';
import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';

@Component({
  selector: 'mj-unit-tree',
  templateUrl: 'unit-tree.component.html',
  styleUrls: ['unit-tree.component.scss'],
})
export class UnitTreeComponent implements OnChanges {
  @Input() treeData: Unit[] = [];
  @Input() unit: Unit;
  @Output() selectUnit: EventEmitter<{
    unit: Unit;
    refresh: boolean;
  }> = new EventEmitter<{ unit: Unit; refresh: boolean }>();

  treeControl = new NestedTreeControl<Unit>(node => node.children);
  dataSource = new MatTreeNestedDataSource<Unit>();

  activeNode: Unit;
  nodeSelected: boolean = false;

  hqUnitName: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.treeData &&
      this.treeData &&
      this.treeData.length &&
      !this.nodeSelected &&
      !this.unit
    ) {
      this.selectNode(this.treeData[0]);
      this.nodeSelected = true;
      this.treeControl.expand(this.treeData[0]);
    } else if (this.treeData && this.treeData.length && this.unit.id) {
      this.treeControl.expand(this.treeData[0]);
      this.selectNodeAfterUpdate();
    }
    this.hqUnitName = localStorage.getItem('unit_name');
  }

  hasChild = (_: number, node: Unit) =>
    !!node.children && node.children.length > 0;

  selectNode(node: Unit) {
    this.activeNode = node;
    this.selectUnit.emit({ unit: node, refresh: true });
  }

  selectNodeAfterUpdate() {
    // select node after update
    const newNode = this.findNode(this.treeData, this.unit.id);
    this.activeNode = newNode;
    this.treeControl.expand(this.activeNode);
    this.selectUnit.emit({ unit: newNode, refresh: false });
  }

  findNode(object: any, id: number) {
    if (object.hasOwnProperty('id') && object['id'] === id) {
      return object;
    }
    for (let i = 0; i < Object.keys(object).length; i++) {
      if (typeof object[Object.keys(object)[i]] === 'object') {
        const o = this.findNode(object[Object.keys(object)[i]], id);
        if (o != null) {
          return o;
        }
      }
    }

    return null;
  }
}
